// extracted by mini-css-extract-plugin
export default {"JobworkFormModal":"JobworkFormModal_JobworkFormModal__fPL+B"};